import { Checkbox, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { Folder } from '@material-ui/icons';
import React, { useCallback } from 'react';
import { useSelection } from "../hooks/index.js";
/**
 * Represents a list picker component.
 */
export function SearchPicker(props) {
  const {
    selection,
    setSelection,
    allowMultiple
  } = useSelection();
  const onCheckedChangeHandler = useCallback((_event, node) => {
    const newSelection = allowMultiple ? selection.filter(item => item.Id !== node.Id) : [];
    if (newSelection.length === selection.length || !allowMultiple && selection[0].Id !== node.Id) {
      newSelection.push(node);
    }
    setSelection(newSelection);
  }, [allowMultiple, selection, setSelection]);
  const defaultRenderer = useCallback(item => {
    var _props$selectionBlack, _props$renderIcon;
    const labelId = `checkbox-list-label-${item.Id}`;
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.Id,
      button: true
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, !((_props$selectionBlack = props.selectionBlacklist) !== null && _props$selectionBlack !== void 0 && _props$selectionBlack.includes(item.Path)) && /*#__PURE__*/React.createElement(Checkbox, {
      color: "primary",
      edge: "start",
      checked: selection.some(selected => selected.Id === item.Id),
      onChange: e => onCheckedChangeHandler(e, item),
      onDoubleClick: e => e.stopPropagation(),
      tabIndex: -1,
      disableRipple: true,
      inputProps: {
        'aria-labelledby': labelId
      }
    })), /*#__PURE__*/React.createElement(ListItemIcon, null, ((_props$renderIcon = props.renderIcon) === null || _props$renderIcon === void 0 ? void 0 : _props$renderIcon.call(props, item)) || /*#__PURE__*/React.createElement(Folder, {
      style: {
        color: 'primary'
      }
    })), /*#__PURE__*/React.createElement(ListItemText, {
      id: labelId,
      primary: item.DisplayName,
      secondary: item.Path.replace(new RegExp('^/Root', 'g'), '')
    }));
  }, [selection, onCheckedChangeHandler, props]);
  const renderItem = props.renderItem || defaultRenderer;
  if (props.error) {
    var _props$renderError;
    return ((_props$renderError = props.renderError) === null || _props$renderError === void 0 ? void 0 : _props$renderError.call(props, props.error)) || /*#__PURE__*/React.createElement(Typography, {
      color: "error",
      variant: "caption"
    }, props.error);
  }
  return /*#__PURE__*/React.createElement(List, null, props.items.map(item => /*#__PURE__*/React.createElement("div", {
    "data-testid": "search-list-item-container",
    onClick: e => onCheckedChangeHandler(e, item),
    onDoubleClick: e => e.stopPropagation(),
    key: item.Id
  }, renderItem(item))));
}
//# sourceMappingURL=search-picker.js.map